import api from "./api";

const route = "/avances";

export default {
  getUltimoAvance: (idProyecto) => api.get(`${route}/${idProyecto}/ultimo`),
  getAvancesDia: (idProyecto, desde, hasta) =>
    api.get(`${route}/${idProyecto}/dia`, { params: { desde, hasta } }),
  getAvancesDestajo: (idProyecto, idDestajo) =>
    api.get(`${route}/${idProyecto}/destajo/${idDestajo}`),
  postAvance: (idProyecto, data) =>
    api.post(`${route}/${idProyecto}`, { ...data }),
  postAvancePartida: (idProyecto, data) =>
    api.post(`${route}/${idProyecto}/partida`, { ...data }),
};
